import React, { useState, useEffect, useRef } from "react";
import { MdCancel } from "react-icons/md";
import axios from "axios";
import { Form, Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "./GiftMerchandiseForm.css";

const GiftMerchandiseForm = () => {
  const [formData, setFormData] = useState();
  const [wordCount, setWordCount] = useState(0);
  const [item_list, setitem_list] = useState([]);
  const [change, setchange] = useState(false);
  const [phone, setphone] = useState();
  const ref = useRef(null);
  const [target, settarget] = useState(null);
  const [success, setsuccess] = useState(false);
  const [place, setplace] = useState(true);
  const [name, setname] = useState();
  const [loading, setloading] = useState(false);

  const merchandise = JSON.parse(localStorage.getItem("Merchandise"));

  const formHandler = async (e) => {
    let inputValue = e.target.value;
    if (e.target.name === "message" && inputValue.length <= 200) {
      setWordCount(inputValue.length);
    } else if (e.target.name === "message" && inputValue.length > 200) {
      return false;
    }
    setFormData({ ...formData, [e.target.name]: inputValue });
  };

  if (formData) {
    localStorage.setItem("Merchandise", JSON.stringify(formData));
  }
  useEffect(() => {
    if (merchandise) {
      setFormData(merchandise);
    }
  }, []);

  const submitMerchandiseForm = (event) => {
    settarget(event.target);
    event.preventDefault();
    var form = document.getElementById("merchandiseForm");
    form.classList.add("was-validated");
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (!phone || phone.length <= 3) {
      event.stopPropagation();
    } else {
      setloading(true);
      console.log(formData);
      let number;
      number =
        phone.substring(0, 3) +
        " " +
        phone.substring(3, 8) +
        " " +
        phone.substring(8, phone.length);
      const body = {
        name: formData.fullName,
        email: formData.email,
        message: formData.message ? formData.message : "",
        phone: number,
        value: "₹" + String(formData.value),
        itemList: item_list,
      };
      axios
        .post(
          "https://5qahboc8gj.execute-api.ap-south-1.amazonaws.com/production/gift",
          body
        )
        .then((res) => {
          console.log("Success");
          setname(formData?.name);
          setFormData({
            fullName: "",
            email: "",
            message: "",
            value: "",
          });
          localStorage.removeItem("Merchandise");
          setphone("");
          setitem_list([]);
          setloading(false);
          setsuccess(true);
        })
        .catch((err) => {
          console.log("Error");
        });
    }
  };

  const add_item = (e) => {
    if (e.target.value || !(e.target.value === "")) {
      const itemList = item_list;
      if (e.key === "Enter") {
        e.preventDefault();
        if (item_list.length !== 8) {
          setitem_list([...item_list, e.target.value]);
          e.target.value = "";
        }
      }
      setchange(!change);
      localStorage.setItem("item_list", JSON.stringify(itemList));
    }
  };

  const delete_item = (e) => {
    const div = e.target.parentNode.parentNode;
    const item_name = div.getElementsByTagName("p")[0].textContent;
    //console.log(item_name)
    item_list.forEach((item, i) => {
      if (item === item_name) {
        item_list.splice(i, 1);
      }
    });
    setchange(!change);
    localStorage.setItem("item_list", JSON.stringify(item_list));
  };

  return (
    <>
      <section id="merchandiseForm">
        <div className="form-wrapper">
          <div className="form-container scrollbar-hide form-container-gm">
            <Form onSubmit={submitMerchandiseForm} noValidate>
              <Row>
                <Form.Group as={Col}>
                  <div
                    className="mf-items form-control"
                    name="items"
                    type="text"
                    placeholder="List of items*"
                    required
                  >
                    <p
                      className="mb-0 mf-items-para"
                      style={{
                        display: item_list.length === 0 ? "inline" : "none",
                      }}
                    >
                      Enter up to 8 items. After each item, press enter to move
                      to the next.
                    </p>
                    <div className="row align-items-center ml-2">
                      {item_list?.map((item) => (
                        <div className="mf-items-row-div">
                          <p style={{ marginBottom: "2px" }}>{item}</p>
                          <MdCancel
                            className="mf-items-row-div-icon"
                            onClick={delete_item}
                          />
                        </div>
                      ))}
                      <input
                        placeholder="Item Name"
                        className="mf-items-row-div-input"
                        style={{
                          display: item_list.length === 8 ? "none" : "inline",
                        }}
                        onKeyPress={add_item}
                        onChange={() => setplace(false)}
                      />
                    </div>
                  </div>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col}>
                  <input
                    type="text"
                    value={formData ? formData.fullName : ""}
                    name="fullName"
                    className="form-control mt-2 padding-right-5px"
                    placeholder="Firm/Personal Name*"
                    required
                    onChange={formHandler}
                  />
                  <input
                    type="email"
                    value={formData ? formData.email : ""}
                    name="email"
                    className="form-control mt-2 padding-right-5px"
                    placeholder="Email*"
                    required
                    onChange={formHandler}
                  />
                  <input
                    name="value"
                    type="number"
                    value={formData ? formData.value : ""}
                    className="form-control mt-2 col-md-2"
                    placeholder="Approx ₹-value*"
                    onChange={formHandler}
                    required
                  />
                </Form.Group>
              </Row>
              <Row className="mt-2">
                <Form.Group as={Col}>
                  <PhoneInput
                    className="border-radius-4px"
                    id="phone-input"
                    placeholder="Phone #*"
                    international
                    value={phone}
                    defaultCountry="IN"
                    countryCallingCodeEditable={false}
                    onChange={setphone}
                    required
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col}>
                  <textarea
                    name="message"
                    placeholder="Message"
                    className="form-control mt-2 height-150px"
                    onChange={formHandler}
                    value={formData ? formData.message : ""}
                  ></textarea>
                  <div className="wordCount">{wordCount}/200</div>
                </Form.Group>
              </Row>
              <Row className="mt-3 mb-2 d-flex justify-content-center">
                <button
                  className="submitFormBtn"
                  onClick={submitMerchandiseForm}
                >
                  Gift
                </button>
              </Row>
            </Form>
          </div>
        </div>
      </section>
    </>
  );
};

export default GiftMerchandiseForm;
